(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("JSUtl", [], factory);
	else if(typeof exports === 'object')
		exports["JSUtl"] = factory();
	else
		root["JSUtl"] = factory();
})((typeof self !== 'undefined' ? self : this), function() {
return 